import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import utilsGraficos from "../../../utils/utilsGraficos";
import FiltroBar from "./FiltroBar";
import ComparativoUnidadeMes from "./ComparativoUnidadeMes";
import PorTipoFinanciamento from "./PorTipoFinanciamento";
import TreemapComparativo from "./TreemapComparativo";
import ResumoModalidades from "./ResumoModalidades";
import ResumoUniplan from "./ResumoUniplan";
import Exportar from "./Exportar";

export default class DashboardConsolidado extends Component {

    constructor(props) {
        super(props);

        this.state = {
            linhas: [],
            carregando: true,
            unidade: [],
            mes: "Anual",
            tipo: [],
            modalidade: [],
            campo: "numTotalMatriculas",
        }
    }

    async componentDidMount() {
        await this.carregarLinhas();
    }

    carregarLinhas = async () => {
        this.setState({ carregando: true });
        try {
            let resposta = await api.get("/dashboardconsolidado");
            this.setState({ linhas: resposta.data.metas || [], carregando: false });
        } catch (erro) {
            this.setState({ linhas: [], carregando: false });
        }
    }

    // Unidade/Tipo/Modalidade são multi-select (array de valores; array vazio
    // = "Todas", sem filtro). Mês e Métrica continuam single-select — a
    // agregação em todo o dashboard hoje é binária (um mês por vez ou o ano
    // inteiro; uma métrica por vez no gráfico), então viraram array exigiria
    // redesenhar a agregação inteira, não só o filtro.
    onChangeUnidade = (novoArray) => this.setState({ unidade: novoArray });
    onChangeMes = (evento) => this.setState({ mes: evento.target.value });
    onChangeTipo = (novoArray) => this.setState({ tipo: novoArray });
    onChangeModalidade = (novoArray) => this.setState({ modalidade: novoArray });
    onChangeMetrica = (evento) => this.setState({ campo: evento.target.value });

    montaFiltros = () => {
        let { unidade, tipo, modalidade } = this.state;
        let filtros = {};
        if (unidade.length > 0) filtros.unidade = unidade;
        if (tipo.length > 0) filtros.tipo = tipo;
        if (modalidade.length > 0) filtros.modalidade = modalidade;
        return filtros;
    }

    mesEfetivo = () => this.state.mes === "Anual" ? undefined : this.state.mes;

    render() {
        let { linhas, carregando, unidade, mes, tipo, modalidade, campo } = this.state;
        let linhasFiltradas = utilsGraficos.filtrar(linhas, this.montaFiltros());
        let mesEfetivo = this.mesEfetivo();

        return (
            <Fragment>
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="card-title">Dashboard Consolidado</h4>
                        </div>
                    </div>

                    <FiltroBar
                        selectUnidade={this.onChangeUnidade}
                        selectMes={this.onChangeMes}
                        selectTipo={this.onChangeTipo}
                        selectModalidade={this.onChangeModalidade}
                        selectMetrica={this.onChangeMetrica}
                        unidade={unidade}
                        mes={mes}
                        tipo={tipo}
                        modalidade={modalidade}
                        campo={campo}
                    />

                    {carregando ? (
                        <p>Carregando...</p>
                    ) : (
                        <Fragment>
                            <div className="row">
                                <div className="col-md-12">
                                    <Exportar linhas={linhasFiltradas} unidade={unidade} mes={mesEfetivo} />
                                </div>
                            </div>
                            <ComparativoUnidadeMes linhas={linhasFiltradas} campo={campo} mes={mesEfetivo} />
                            <PorTipoFinanciamento linhas={linhasFiltradas} campo={campo} mes={mesEfetivo} />
                            <TreemapComparativo linhas={linhasFiltradas} campo={campo} mes={mesEfetivo} />
                            <ResumoModalidades linhas={linhasFiltradas} mes={mesEfetivo} />
                            <ResumoUniplan linhas={linhasFiltradas} mes={mesEfetivo} />
                        </Fragment>
                    )}
                </div>
            </Fragment>
        )
    }
}
